/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * HomePage.tsx
 */

import HiloReactComponent from "./HiloReactComponent";
import React from "react";
import Header from "../element/Header";
import UserService, {UserListener} from "../../../services/UserService";
import User from "../../../models/User";

export interface PageComponentProps {

}

export interface PageComponentState {
    user?: User;
}

export default class PageComponent extends HiloReactComponent<PageComponentProps, PageComponentState> implements UserListener {
    private readonly _userService: UserService;

    /**
     * constructor
     * @param props
     * @param state
     */
    constructor(props: PageComponentProps, state: PageComponentState) {
        super(props, state);

        this._userService = this._serviceRepository.resolve(UserService.id) as UserService;

        this.state = {
            ...state,
            user: this._userService.user
        };
    }

    /**
     * componentDidMount
     */
    public componentDidMount(): void {
        super.componentDidMount();
        this._userService.addListener(this);
    }

    /**
     * componentWillUnmount
     */
    public componentWillUnmount(): void {
        super.componentWillUnmount();
        this._userService.removeListener(this);
    }

    /**
     * currentUserHasBeenUpdated
     * @param user
     */
    public currentUserHasBeenUpdated(user: User | undefined): void {
        this.setState({user: user});
    }

    /**
     * render
     */
    public render(): JSX.Element {
        const {user} = this.state;
        const {children} = this.props;

        return <div className={"page"}>
            <Header user={user}/>
            <div className={"content"}>
                {children}
            </div>
        </div>
    }
}